import React from "react";
import LVCuadriculaBoton from "./LVCuadriculaBoton";

function LVCuadricula({ data, IdGrupo, CantidadDeBotonesHorizontal, AltoBotones, AnchoBotones, 
  CampoCodigo, CampoDescripcion, onButtonClick, Disabled = false }) {
  if (!data || data.length === 0) {
    return <div></div>;
  }

  // Filtra los datos según el IdGrupo si es necesario
  const datosFiltrados = data.filter(item => IdGrupo > 0 ? item.IdGrupo === IdGrupo : true);

  // Divide los datos en filas según la cantidad de botones por fila
  const filas = [];
  for (let i = 0; i < datosFiltrados.length; i += CantidadDeBotonesHorizontal) {
    filas.push(datosFiltrados.slice(i, i + CantidadDeBotonesHorizontal));
  }

  const colorBotonDeshabilitado = "rgba(0, 0, 0, 0)"; // Color transparente en formato RGBA

  return (
    <div className="LV-GroupBox-div">
      {filas.map((fila, filaIndex) => (
        <div key={`fila-${filaIndex}`} style={{ display: "flex" }}>
          {fila.map((item, index) => {
            return (
              <LVCuadriculaBoton
                key={item[CampoCodigo]}
                Alto={AltoBotones}
                Ancho={AnchoBotones}
                Disabled={Disabled}
                TextoLinea1={item.Habilitado ? item[CampoDescripcion].substring(0, 10) : ""}
                TextoLinea2={item.Habilitado ? item[CampoDescripcion].substring(10, 20) : ""}
                TextoLinea3={item.Habilitado ? (item.ImporteTotal ? `$${item.ImporteTotal}` : '') : ""}
                Color={item.Habilitado ? item.Color : colorBotonDeshabilitado}
                visible={item.Habilitado ? true : false}
                onClick={item.Habilitado ? () => onButtonClick(item[CampoCodigo], item[CampoDescripcion]) : () => {}}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default LVCuadricula;